var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vx-toast",class:_vm.iconsClass == '' ? 'vx-toast-none-icon' : ''},[(_vm.iconsClass)?_c('div',{class:_vm.iconsClass}):_vm._e(),_c('p',{staticClass:"vx-toast-content",domProps:{"innerHTML":_vm._s(_vm.mes)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }